module.exports = __webpack_public_path__ + "static/media/logo.5c00c519.png";